export const parseResourceType = type =>
  ({
    area: 'Área',
    process: 'Processo',
    tool: 'Ferramenta',
    machine: 'Máquina',
  }[type])
